import { render, staticRenderFns } from "./NewTptPatient.vue?vue&type=template&id=5ab4c16e&scoped=true"
import script from "./NewTptPatient.vue?vue&type=script&lang=js"
export * from "./NewTptPatient.vue?vue&type=script&lang=js"
import style0 from "./NewTptPatient.vue?vue&type=style&index=0&id=5ab4c16e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab4c16e",
  null
  
)

export default component.exports